import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const Chevron = ({ color, className }) => (
    <svg
        width="7"
        height="11"
        viewBox="0 0 7 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M0.351562 0.349609L5.35156 5.34961L0.351562 10.3496"
            stroke={color}
            strokeMiterlimit="10"
        />
    </svg>
);

Chevron.propTypes = propTypes;
Chevron.defaultProps = defaultProps;

export default Chevron;
